/** @type {import('../schema').ProcessDefinition} */
const activacionCuenta = {
  id: "activacion-cuenta",
  name: "Activación e invitación de residente",
  category: "personas",
  outcome:
    "Un residente recibe una invitación por email/WhatsApp con un enlace tokenizado y activa su cuenta.",
  trigger:
    "El Administrador invita a un residente desde Cuentas/Residentes o por carga masiva.",
  actors: ["Administrador", "Sistema", "Residente"],
  status: "COMPLETO",
  description:
    "Invitación tokenizada a un residente, asignación a unidad, apertura de tenencia y activación de cuenta con consentimiento (Ley 18.331).",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Invitación del residente",
      description:
        "El Administrador invita a un residente desde Cuentas/Residentes o por carga masiva.",
      evidence: "functions/identity/residentes.js:670 (inviteResident), :1198 (importarUnidades)",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "task",
      label: "Búsqueda / detección",
      description:
        "Busca al usuario por email/documento y decide: crear, reinvitar o asignar a otra unidad.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "task",
      label: "Alta o regeneración de token",
      description:
        "Crea el usuario o regenera el activationToken con expiración (48 h).",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "task",
      label: "Asignación a unidad",
      description:
        "Vincula apartments (owner/tenant) y crea userbuilding (idempotente). Si viene effectiveDate, abre la occupancy y cierra la del saliente (ver proración).",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "notification",
      label: "Notificación del enlace",
      description:
        "Envía el enlace /activar/{token} por email/WhatsApp al residente.",
    },
    {
      id: "s6",
      laneId: "res",
      type: "task",
      label: "Activación de la cuenta",
      description:
        "Abre el enlace, valida su documento y crea su contraseña; el servidor activa la cuenta, asocia la unidad y registra el consentimiento (Ley 18.331).",
      evidence: "src/screens/ActivarCuenta.jsx",
    },
    {
      id: "s7",
      laneId: "res",
      type: "end",
      label: "Cuenta activa",
      description:
        "Usuario activo (activatedAt, token nulo).",
    },
    {
      id: "s8",
      laneId: "sys",
      type: "end",
      label: "Invitación expirada",
      description:
        "Token vencido: pantalla de expiración que pide un nuevo enlace.",
      evidence: "src/screens/ActivacionExpirada.jsx",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "Crear / reinvitar" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6", label: "Token vigente" },
    { from: "s5", to: "s8", label: "Token vencido" },
    { from: "s6", to: "s7" },
  ],
};
export default activacionCuenta;
